import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface Language {
  label: string;
  code: string;
}

/**
 * Returns the selectable UI languages with their translated labels,
 * in display order (German, English, French).
 */
export const useGetLanguages = (): Language[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t("Languages.german"), code: "de" },
      { label: t("Languages.english"), code: "en" },
      { label: t("Languages.french"), code: "fr" },
    ],
    [t],
  );
};
